import React from "react";
import StakeSGTComponent from "./components/StakeSGTComponent";

const StakeSgt = () => {
  return (
    <div>
      <StakeSGTComponent type="stake" />
    </div>
  );
};
export default StakeSgt;
